import React, { useMemo, useEffect } from 'react';
import { func } from 'prop-types';
import noop from 'lodash/noop';
import isNil from 'lodash/isNil';
import { useSelector } from 'react-redux';
import Locale from '@active/react-utils/i18n/Locale';
import PromptMessage from '../../../information/PromptMessage';
import getPaymentMethodInfo from './utils/getPaymentMethodInfo';

const PaymentMethod = ({ trackingCallback }) => {
  const {
    isShowCashCalculator,
    paymentMethodMessage,
  } = useSelector(state => state.propsData);
  const { currentActivePaymentMethod } = useSelector(state => state.paymentMethods);

  useEffect(() => {
    trackingCallback({ id: `paymentMethod.${currentActivePaymentMethod}` });
  }, [ currentActivePaymentMethod, trackingCallback ]);

  const { component: RealPaymentMethod, showTitle } = useMemo(() => getPaymentMethodInfo(currentActivePaymentMethod),
    [ currentActivePaymentMethod ]);

  const showPaymentInfoTitle = useMemo(() => (currentActivePaymentMethod === 'CASH' ? !!isShowCashCalculator : !!showTitle), [ currentActivePaymentMethod, isShowCashCalculator, showTitle ]);

  return (
    <>
      <div className="checkout-ui-component__payment-method">
        {
          showPaymentInfoTitle && <h4 className="cui-mg-t-30 cui-mg-b-0">
            <Locale id={'checkout.lib.components.payment.paymentMethod.title'}/>
          </h4>
        }
        {!isNil(paymentMethodMessage) && <PromptMessage message={paymentMethodMessage}/>}
        {
          RealPaymentMethod && <RealPaymentMethod />
        }
      </div>
    </>
  );
};

PaymentMethod.propTypes = {
  trackingCallback: func,
};

PaymentMethod.defaultProps = {
  trackingCallback: noop,
};

export default PaymentMethod;
